// extracted by mini-css-extract-plugin
export default {"wrapper":"qqo-0"};